import React, { useEffect } from "react";
import fastFood from "../../assets/newLogo.jpeg";
import Footer from "../../components/Footer/Footer";
import styles from "./Earnings.module.css";

import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getDeliveredOrder } from "../../redux/actions/orderActions";

const Earnings = ({ history }) => {
  const getDeliveredOrd = useSelector((state) => state.getDeliveredOrder);
  const { loading, deliveredOrder: orders, error } = getDeliveredOrd;

  const { adminInfo } = useSelector((state) => state.adminLoginReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    if (adminInfo) {
      dispatch(getDeliveredOrder());
    } else {
      history.push("/");
    }
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.box}></div>
      <header>
        <h2>Earnings</h2>
        <h1>$ {orders && orders.earnings}</h1>
      </header>

      <main>
        <p className={styles.status}>Recent Transaction</p>

        {loading && <h2 className={styles.status}>Loading deliveries ...</h2>}
        {error && <h2>{error}</h2>}
        {orders &&
          orders.orders.map((order) => (
            <div key={order._id}>
              {order.status === "delivered" && (
                <>
                  <div className={styles.card}>
                    <img src={fastFood} alt="fast-food" />
                    <div className={styles.name}>
                      <h3>{order.typeOfOrder}</h3>
                      <small>Economy Delivery</small>
                    </div>
                    <div className={styles.deliveryStatus}>
                      {/* <small>$ {order.payment_amount}</small> */}
                      <h5>Paid via {order.payment}</h5>
                    </div>
                    <div className={styles.deliveryStatus}>
                      <small>$ {order.payment_amount}</small>
                      <h5>Earned</h5>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
      </main>
      <Footer />
    </div>
  );
};

export default Earnings;
